<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row" style="padding:0px">
    <div *ngIf="isLoaded" class="col-sm-12">
        <div class="card">
            <div class="card-body" style="padding:20px;">
                <div style="display: flex;cursor:pointer">
                    <!--<input (keyup)="searchEnter($event)" [(ngModel)]="search_text" class="form-control" placeholder="Search..." type="text" style="background-color:white; border-radius: 30px;">-->
                    <input  [(ngModel)]="search_text" class="form-control" placeholder="Search..." type="text" style="background-color:white; border-radius: 30px;">
                </div>
            </div>
        </div>
    </div>
    <div *ngFor="let article of articles | filterBy: ['title']: search_text: false" class="col-md-6 col-xl-3 box-col-6 xl-50">
        <div *ngIf="article.navigateType == 'internal'" (click)="openArticle(article.id, true)" class="card" style="min-height: 377px; cursor:pointer">
            <div class="blog-box blog-grid text-center">
                <img class="img-fluid top-radius-blog"
                     [src]="article.coverImage" alt="">
                <div class="blog-details-main">
                    <ul class="blog-social">
                        <li class="digits">{{article.publishedDate | date}}</li>
                        <li class="digits">{{article.authorName}}</li>
                        <li class="digits">{{article.source}}</li>
                        <li class="digits">Hits: {{article.viewCount}}</li>
                    </ul>
                    <hr>
                    <h6 class="blog-bottom-details">{{article.title}}</h6>
                </div>
            </div>
        </div>
        <a (click)="openArticle(article.id, false)" *ngIf="article.navigateType == 'external'" [href]="article.navigateUrl" target="_blank" class="card" style="min-height: 377px">
            <div class="blog-box blog-grid text-center">
                <img class="img-fluid top-radius-blog"
                     [src]="article.coverImage" alt="">
                <div class="blog-details-main">
                    <ul class="blog-social">
                        <li class="digits">{{article.publishedDate | date}}</li>
                        <li class="digits">{{article.authorName}}</li>
                        <li class="digits">{{article.source}}</li>
                        <li class="digits">Hits: {{article.viewCount}}</li>
                    </ul>
                    <hr>
                    <h6 class="blog-bottom-details">{{article.title}}</h6>
                </div>
            </div>
        </a>
    </div>
</div>            

